import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="w-full bg-dark text-white px-4 py-3 shadow-md z-50 relative">
      <div className="flex justify-between items-center w-full max-w-6xl mx-auto">
        <Link to="/" className="text-xl font-bold text-gold">
          BK Portfolio
        </Link>

        {/* Mobile Toggle Button */}
        <button
          className="md:hidden focus:outline-none"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle Menu"
        >
          {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>

        {/* Desktop Navigation */}
        <ul className="hidden md:flex gap-6 font-medium">
          <li><Link to="/" className="hover:text-gold">Home</Link></li>
          <li><Link to="/projekte" className="hover:text-gold">Projekte</Link></li>
          <li><Link to="/zertifikate" className="hover:text-gold">Zertifikate</Link></li>
          <li><Link to="/profil" className="hover:text-gold">Profil</Link></li>
          <li><Link to="/Kenntnisse" className="hover:text-gold">Kenntnisse</Link></li>
          <li><Link to="/kontakt" className="hover:text-gold">Kontakt</Link></li>
        </ul>
      </div>

      {/* Mobile Overlay Menu */}
      {isOpen && (
        <div className="fixed inset-0 z-50 bg-marine/90 backdrop-blur-md flex flex-col gap-6 items-center justify-center text-xl font-medium">
          <Link to="/" onClick={() => setIsOpen(false)} className="hover:text-gold">Home</Link>
          <Link to="/projekte" onClick={() => setIsOpen(false)} className="hover:text-gold">Projekte</Link>
          <Link to="/zertifikate" onClick={() => setIsOpen(false)} className="hover:text-gold">Zertifikate</Link>
          <Link to="/profil" onClick={() => setIsOpen(false)} className="hover:text-gold">Profil</Link>
          <Link to="/Kenntnisse" onClick={() => setIsOpen(false)} className="hover:text-gold">Kenntnisse</Link>
          <Link to="/kontakt" onClick={() => setIsOpen(false)} className="hover:text-gold">Kontakt</Link>
        </div>
      )}
    </nav>
  );
}
